var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _c("popup-edit-version", { ref: "popup-edit-version" }),
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _vm.isProduction()
                ? _c(
                    "v-card-actions",
                    { staticClass: "ma-0 pa-2" },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: { type: "warning", dense: "", width: "100%" },
                        },
                        [_vm._v("Only deploy log (Staging -> Production)")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isDevelopment()
                ? _c(
                    "v-card-actions",
                    { staticClass: "ma-0 pa-2" },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "0", width: "100%" } },
                        _vm._l(_vm.assetUploadResult, function (r) {
                          return _c(
                            "v-card",
                            { attrs: { elevation: "0", width: "100%" } },
                            [
                              _c(
                                "v-card-actions",
                                { staticClass: "ma-0 pa-0" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "white--text mb-1",
                                      attrs: {
                                        color:
                                          r.success == "OK"
                                            ? "success"
                                            : "error",
                                        width: "100%",
                                        elevation: "0",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { color: "white" },
                                            },
                                            [_vm._v("mdi-alert-circle-outline")]
                                          ),
                                          _vm._v(" " + _vm._s(r.name) + " "),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isProduction()
                ? _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { outlined: "", width: "100%" },
                        },
                        [
                          _c(
                            "v-card-actions",
                            { staticClass: "ma-0 pa-2" },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            elevation: "0",
                                            color: "blue",
                                          },
                                          on: { click: _vm.editVersion },
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              ref: "versionValue",
                                              staticClass: "white--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.minVersion.join(".")
                                                ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.maxVersion.join(".")
                                                  )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "20",
                                                color: "white",
                                              },
                                            },
                                            [_vm._v("mdi-pencil")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-checkbox", {
                                staticClass: "ml-5",
                                attrs: { label: "Localization" },
                                model: {
                                  value: _vm.localization,
                                  callback: function ($$v) {
                                    _vm.localization = $$v
                                  },
                                  expression: "localization",
                                },
                              }),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "white--text pl-5 pr-3",
                                  attrs: {
                                    loading: _vm.deployng,
                                    disabled: !_vm.ifCanDeployToNext(),
                                    color: "green",
                                    elevation: "0",
                                  },
                                  on: { click: _vm.onPressDeploy },
                                },
                                [
                                  _vm._v(
                                    " deploy " +
                                      _vm._s(_vm.getDeployButtonName()) +
                                      " "
                                  ),
                                  _c("v-icon", { staticClass: "ml-2" }, [
                                    _vm._v("mdi-bird"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isProduction()
                ? _c(
                    "v-card-actions",
                    { staticClass: "pt-0" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [_c("d-list-table", { ref: "d-list-table" })],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }